module.exports = __webpack_public_path__ + "static/standard2-0086545312dc36fb1a3bc7dd3512f3d3.png";